import React from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';

/** Persistent mini-cart pill. Hidden on product pages (they have their own sticky buy bar) and on the cart page. */
export function FloatingCart() {
  const {
    count,
    subtotal,
    openCart,
    isOpen
  } = useCart();
  const {
    pathname
  } = useLocation();
  const visible = count > 0 && !isOpen && !pathname.startsWith('/product') && pathname !== '/cart';
  return <AnimatePresence data-id="element-62" data-mp="2c8832446g47y">
      {visible && <motion.button type="button" onClick={openCart} initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-5 right-5 z-40 flex items-center gap-3 rounded-full bg-ink py-2 pl-2 pr-5 text-white shadow-[0_12px_32px_-8px_rgba(14,26,36,0.45)] hover:bg-ink-soft" aria-label={`Open cart, ${count} items, ${formatPrice(subtotal)}`} data-id="element-63" data-mp="2c76ovqrv71m0">
          <span className="relative flex h-10 w-10 items-center justify-center rounded-full bg-volt text-ink" data-id="element-64" data-mp="8q5s6vaftpsw">
            <ShoppingCartIcon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-65" data-mp="3w1msggtlptx" />
            <span className="absolute -right-1 -top-1 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-white px-1 text-[11px] font-bold text-ink ring-2 ring-ink" data-id="element-66" data-mp="hny9u63mt9jg">
              {count}
            </span>
          </span>
          <span className="text-left leading-tight" data-id="element-67" data-mp="mom9th9u90pt">
            <span className="block text-[11px] text-white/60" data-id="element-68" data-mp="mp5hm55ry8q4">View cart</span>
            <span className="block text-sm font-bold" data-id="element-69" data-mp="2teaf7qg7o6rf">{formatPrice(subtotal)}</span>
          </span>
        </motion.button>}
    </AnimatePresence>;
}